import React from 'react';
import rawMarkup from '../../util/rawMarkup';
import config from '../../config';
import googleTagManagerConfig from 'config/googleTagManager';

const { GOOGLE_TAG_MANAGER_ENV } = config;

export default class GoogleTagManagerScript extends React.Component {
  render() {
    let script = `function initGTM(w,d,s,l,i,r){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      '//www.googletagmanager.com/gtm.js?id='+i+dl+r;f.parentNode.insertBefore(j,f);
    };`;
    

    googleTagManagerConfig[
      this.props.country
    ].forEach(({ containerId, dataLayer, environments }) => {
      const environment = GOOGLE_TAG_MANAGER_ENV
        ? environments[GOOGLE_TAG_MANAGER_ENV]
        : null;
      let params = '';
      if (environment) {
        params += '&gtm_preview=env-' + environment.id;
        params += '&gtm_auth=' + environment.auth;
      }
      script += `\ninitGTM(window,document,'script','${dataLayer ||
        'dataLayer'}','${containerId}','${params}');`;
    });
    script += '\n';

    return (
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={rawMarkup(script)}
      />
    );
  }
}

GoogleTagManagerScript.propTypes = {
  country: React.PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/component/Page/GoogleTagManagerScript.jsx